export const REG_EXP_EMAIL =
  /^(?!.*[\u0080-\uFFFF])(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

export const REG_EXP_DECIMAL = /^-?\d+([.,]\d+)?$/

export const REG_EXP_FLOAT = /^\d+([,]\d+)*$/

export const REG_EXP_INTEGER = /^\d+$/

export const REG_EXP_UNSIGNED_DECIMAL = /^\d+(\.\d+)?$/

export const REG_EXP_WEBSITE = /^([a-zA-Z][a-zA-Z\d+\-.]*):\/\//

export const REG_EXP_SLASH_ON_END = /\/$/

export const REG_EXP_PASSWORD_REQUIREMENT =
  /^(?=.*[A-ZÄÖÜ])(?=.*[a-zäöüß])(?=.*\d)[A-Za-zÄÖÜäöüß\d~!?@#$%^&*_\-+[\]{}()<>/\\|"'.,:;]{8,30}$/

export const REG_EXP_URL_PATTERN =
  /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/[^\s]*)?(\?[^\s]*)?$/

export const REG_EXP_URL_IN_TEXT =
  /((?:https?:\/\/|ftps?:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,})|(\n+|(?:(?!(?:https?:\/\/|ftp:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,}).)+)/gim

export const REG_EXP_BIC = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/

export const REG_EXP_PHONE_PREFIX = /^(?:00|\+)/

export const REG_EXP_URL_STARTS_WITH_WWW = /^www\./i

export const REG_EXP_URL_START = /^(?:https?:\/\/|ftps?:\/\/|www\.)/i

export const REG_EXP_URL_PRESENT = /(https?:\/\/|ftps?:\/\/|www\.)/i

export const REG_EXP_EMAIL_IN_TEXT =
  /([A-Za-z0-9._%+-]{1,64}@[A-Za-z0-9.-]{1,253}\.[A-Za-z]{2,24})/i

export const REG_EXP_HTML_ANCHOR_PRESENT = /<a[\s>]/i

export const REG_EXP_NEW_LINE = /\r\n|\r|\n/

export const REG_EXP_WYSIWYG_HTML_START = /^<(p|ol|ul|blockquote)\b/

// Layout only, without the RFC 4122 version/variant nibbles, to stay exactly as
// permissive as the backend's UUID parser.
export const REG_EXP_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
